import React, {Component} from 'react';
import {cloneDeep} from 'lodash';
import {createFragmentContainer, graphql} from 'react-relay';
import MissionControlHeader from './mission_control_header';

class npsResults extends Component {
	constructor(props) {
		super(props);
		this.state = {
			sortField: 'id',
			sortAsc: false,
		};
		this.fields = ['id', 'date', 'type', 'score', 'comment', 'companyName', 'personName', 'personType', 'personRole', 'personEmail', 'personErrors'];
		this.columnNames = ['Id', 'Date', 'Type', 'Score', 'Comment', 'Company', 'Name', 'User Type', 'Role', 'Email', 'Errors'];
	}

	setSort(field) {
		const {sortField, sortAsc} = this.state;
		const ascending = sortField !== field || !sortAsc;
		this.setState({sortField: field, sortAsc: ascending});
	}

	sort(data) {
		const {sortField, sortAsc} = this.state;
		const direction = sortAsc ? 1 : -1;
		return data.sort((a, b) => {
			if (sortField === 'id' || sortField === 'score' || sortField === 'personErrors') {
				if (Number(a[sortField]) > Number(b[sortField])) {
					return direction;
				}
				if (Number(a[sortField]) < Number(b[sortField])) {
					return -direction;
				}
			} else {
				if (a[sortField] > b[sortField]) {
					return direction;
				}
				if (a[sortField] < b[sortField]) {
					return -direction;
				}
			}

			// Use the id field as a tiebreaker
			return a.id > b.id ? direction : -direction;
		});
	}

	getLine(entry, index) {
		return (
			<tr key={index}>
				{this.fields.map((field, index) => {
					return <td key={index}>{entry[field]}</td>;
				})}
			</tr>
		);
	}

	render() {
		const npsResults = cloneDeep(this.props.viewer.missionControlData.npsResults);
		const formattedNpsResults = npsResults.map(result => ({...result, id: atob(result.id).replace(/^.*:/, '')}));
		const sortedData = this.sort(formattedNpsResults);
		return (
			<div className="mission-control-list">
				<MissionControlHeader viewer={this.props.viewer} />
				<h1>NPS Results</h1>
				<table>
					<thead>
						<tr>
							{this.columnNames.map((column, index) => (
								<th key={index} onClick={this.setSort.bind(this, this.fields[index])}>
									{column}
								</th>
							))}
						</tr>
					</thead>
					<tbody>{sortedData.map((result, index) => this.getLine(result, index))}</tbody>
				</table>
			</div>
		);
	}
}

const npsResultsQuery = graphql`
	query npsResults_Query {
		viewer {
			actualPersonId
			component(name: "control_nps_results")
			...npsResults_viewer
		}
	}
`;

export {npsResultsQuery};

export default createFragmentContainer(npsResults, {
	viewer: graphql`
		fragment npsResults_viewer on Viewer {
			id
			...missionControlHeader_viewer
			missionControlData {
				id
				npsResults {
					id
					date
					type
					score
					comment
					companyName
					personName
					personRole
					personEmail
					personType
					personErrors
				}
			}
		}
	`,
});
